/**
 * API Configuration Utility
 * 
 * This utility provides the correct API URL based on the current environment.
 * In development mode, it uses localhost.
 * In production mode, it uses the deployed backend URL.
 */

// Default URLs
const LOCAL_API_URL = 'http://localhost:4001';
// Use backend API origin in production to avoid CORS from static site
const PROD_API_URL = 'https://dashbasket.onrender.com';

// Get API URL from environment variables if available
const API_URL = import.meta.env.VITE_API_URL || LOCAL_API_URL;
const PROD_API_URL_ENV = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '') || PROD_API_URL;

/**
 * Determines the correct API URL based on environment
 * @returns {string} The API URL to use
 */
export const getApiUrl = () => {
  // Check if we're in development mode
  const isDevelopment = 
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1';
  
  // Use local API in development, production API otherwise
  return isDevelopment ? API_URL : PROD_API_URL_ENV;
};

/**
 * Gets the full URL for a specific API endpoint
 * @param {string} endpoint - The API endpoint path (e.g., '/api/users')
 * @returns {string} The complete URL
 */
export const getEndpointUrl = (endpoint) => {
  const baseUrl = getApiUrl();
  // Make sure we don't have double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

export default {
  getApiUrl,
  getEndpointUrl
}; 